import { useMemo } from "react";

import { useConsultTimes } from "features/practice/hooks/useConsultTimes";

export const useGetDurationOptions = (
  time,
  allTimes,
  appointmentType,
  slotDurationMinutes,
  initialDuration
) => {
  const {
    data: consultTimes,
    isLoading,
    isError,
    refetch,
  } = useConsultTimes();

  const durationOptions = useMemo(() => {
    const fromConfig = (consultTimes || []).map((minutes) => ({
      label: String(minutes),
      value: String(minutes),
    }));

    const filtered = fromConfig.filter((option) => {
      const timeIndex = allTimes?.findIndex((t) => t === time);
      const remainingSlots = allTimes ? allTimes.length - timeIndex : 0;
      const remainingMinutes = remainingSlots * slotDurationMinutes;
      const optionMinutes = parseInt(option.value, 10);

      return optionMinutes <= remainingMinutes;
    });

    if (
      initialDuration &&
      !filtered.some((option) => option.value === String(initialDuration))
    ) {
      return [
        ...filtered,
        { label: String(initialDuration), value: String(initialDuration) },
      ];
    }

    return filtered;
  // eslint-disable-next-line react-hooks/exhaustive-deps -- slotDurationMinutes is stable
  }, [consultTimes, allTimes, time, appointmentType, initialDuration]);

  return {
    durationOptions,
    consultTimes: consultTimes || [],
    isLoading,
    isError,
    refetch,
    hasNoConsultTimes:
      !isLoading && !isError && (consultTimes || []).length === 0,
  };
};
